import { defineComponent as _defineComponent } from 'vue'
import store from '@/store'
import api from '@/api'

import CreateEventAddBattle from '@/pages/CreateEventProcessingPage/ui/CreateEventAddBattle.vue'
import CreateEventCancel from '@/pages/CreateEventProcessingPage/ui/CreateEventCancel.vue'
import { BKConfirmationDialog } from '@/shared/ui/modals'
import { mdiLeadPencil, mdiPlus, mdiTrashCanOutline } from '@mdi/js'
import { battleApi, BattleDB, useBattle } from '@/enitites/battle'
import { CreateEventFormName } from '@/pages/CreateEventProcessingPage/model/types'
import { EventDB } from '@/enitites/event'
import { getCurrentInstance, inject, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventBattles',
  props: {
    isNew: { type: Boolean },
    screen: null,
    eventData: null,
    backStep: { type: Boolean }
  },
  emits: ["update:screen", "saveAsDraft"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:screen', value: CreateEventFormName): void
  (e: 'saveAsDraft'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isNew: boolean
  screen: CreateEventFormName
  eventData: EventDB
  backStep: boolean
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const { getBattleCategoryName } = useBattle()




const dialog = ref(false)
const currentBattleId = ref(0)
const loadingNextBtn = ref(false)
const loadingAddBtn = ref(false)
const currentDotNav = ref(5)
const error = ref<null | string>(null)
const confirmationDialog = ref({
  isShow: false,
  title: '',
  subtitle: '',
  confirmText: '',
  confirm: () => {},
})

const injectedIsClickBtnNext = inject<{
  updateIsClickBtnNext: (value: boolean) => void
}>('isClickBtnNext')

function handlerClickNext() {
  error.value = null
  loadingNextBtn.value = true
  try {
    injectedIsClickBtnNext?.updateIsClickBtnNext(true)
    emit('update:screen', 'CreateEventTotal')
  } catch {
    error.value = 'Something went wrong'
  } finally {
    loadingNextBtn.value = false
  }
}

async function deleteBattle(battleId: number) {
  const resp = await api.battles.deleteBattle(battleId)
  if (resp) {
    props.eventData.battles = props.eventData.battles.filter((battle) => battle.id !== battleId)
  }
}

function confirmDeleteBattle(id: number) {
  confirmationDialog.value = {
    isShow: true,
    title: 'Delete',
    subtitle: 'Are you sure you want to delete this battle',
    confirmText: 'Delete',
    confirm: () => {
      deleteBattle(id)
      confirmationDialog.value.isShow = false
    },
  }
}

function handlerClickBack() {
  injectedIsClickBtnNext?.updateIsClickBtnNext(false)
  emit('update:screen', 'CreateEventDisplayMode')
}

function handlerClickCancelEdit() {
  emit('update:screen', 'CreateEventTotal')
}

async function addBattle() {
  loadingAddBtn.value = true
  const battle = await battleApi.addBattle(props.eventData.id)
  loadingAddBtn.value = false
  const eventBattleChip = {
    id: battle.id,
    title: battle.title,
    crewSize: battle.crewSize,
    isLimitExceeded: battle.isLimitExceeded,
    isRegistered: false,
    limit: battle.limit,
    orgChip: {
      id: 0,
      name: '',
      image: '',
    },
  }
  if (battle) {
    props.eventData.battles.push(eventBattleChip)
    currentBattleId.value = battle.id
    dialog.value = true
  }
}

const instance = getCurrentInstance()

async function updateBattle(battle: BattleDB) {
  const mutatedBattle = { ...battle }
  if (mutatedBattle.description) {
    mutatedBattle.description = instance?.proxy?.$sanitize(battle.description)
  }
  const resp = await api.battles.update(mutatedBattle)
  if (resp) {
    const battleIndex = props.eventData.battles.findIndex((bat) => bat.id === mutatedBattle.id)
    props.eventData.battles[battleIndex].title = mutatedBattle.title
    props.eventData.battles[battleIndex].crewSize = mutatedBattle.crewSize
  }
}

function handlerClickEdit(battleId: number) {
  currentBattleId.value = battleId
  dialog.value = true
}

return { __sfc: true,getBattleCategoryName, emit, props, dialog, currentBattleId, loadingNextBtn, loadingAddBtn, currentDotNav, error, confirmationDialog, injectedIsClickBtnNext, handlerClickNext, deleteBattle, confirmDeleteBattle, handlerClickBack, handlerClickCancelEdit, addBattle, instance, updateBattle, handlerClickEdit, store, CreateEventAddBattle, CreateEventCancel, BKConfirmationDialog, mdiLeadPencil, mdiPlus, mdiTrashCanOutline }
}

})